/** Duplicate name suffixes the app adds: space + `(copy)` or `(copy #n)`. */
const COPY_SEGMENT = / \(copy(?: #(\d+))?\)/g

/**
 * The name a duplicate is suggested under: ` (copy)`, or ` (copy #n)` once the
 * name already carries one. Each ` (copy)` counts as one generation and each
 * ` (copy #k)` as k, so they add up rather than stacking — "Foo (copy) (copy)"
 * becomes "Foo (copy #3)".
 *
 * A port of `next-copy-title.ts` in the old UI, so a copy is named the same
 * way in both.
 */
export function nextCopyName(name: string | null | undefined): string {
  const value = name ?? ''
  let depth = 0
  const pattern = new RegExp(COPY_SEGMENT.source, 'g')
  let match: RegExpExecArray | null
  while ((match = pattern.exec(value)) !== null) {
    depth += match[1] !== undefined ? parseInt(match[1], 10) : 1
  }
  const base = value.replace(COPY_SEGMENT, '').replace(/ {2,}/g, ' ').trimEnd()
  return depth === 0 ? `${base} (copy)` : `${base} (copy #${depth + 1})`
}
